import { useRef } from "react";
import { notification } from "antd";
import { AxiosResponse } from "axios";
import ModalBase, { IModalBaseProps, ModalBaseRefType } from "../../../Base/ModalBase";
import ViagemFechadaFormBasic, { IViagemFechadaInstanceRef } from "./ViagemFechadaFormBasic";
import { IViagemFechadaInserirParam, useViagemFechadaCancelar, useViagemFechadaInserir, useViagemFechamentoObter } from "../../../../Services/Domain/Viagem/ViagemFechadaService";
import { PropriedadesDeNotificacao } from "../../../../Utils/Notificacoes";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";

interface IViagemFechadaFormModalProps extends IModalBaseProps {
    initialValues:IViagemFechadaInserirParam;
    onSuccess?(data: AxiosResponse<void, any>, variables: IViagemFechadaInserirParam, context: unknown) : void;
}

export default function VaigemFechadaFormModal ({
    initialValues,
    width,
    onOk,
    onCancel,
    onSuccess,
    textButtonOpen,
    propsButtonOpen,
    title,
    ...rest
}:IViagemFechadaFormModalProps) {
    textButtonOpen = textButtonOpen ?? "Fechar viagem";
    propsButtonOpen = propsButtonOpen ?? {};
    propsButtonOpen.size = propsButtonOpen.size ?? "middle";

    const refForm = useRef<IViagemFechadaInstanceRef|null>(null);
    const refModal = useRef<ModalBaseRefType|null>(null);

    const {
        data : dataFechamentoRelatorio,
        isPending : isPendingFechamentoRelatorio,
        isLoading : isLoadingFechamentoRelatorio
    } = useViagemFechamentoObter({
        codViagem : initialValues.viagemFechada.viagem!.codigo!
    });

    const isAlteracao = !!dataFechamentoRelatorio?.codigo;

    const {
        mutate,
        isPending
    } = useViagemFechadaInserir({
        onSuccess(data, variables, context) {
            refModal.current?.fechar();
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Viagem fechada com sucesso."
            });

            onSuccess?.(data, variables, context);
        },
    });

    const {
        mutate : cancelar,
        isPending : isPendingCancelar
    } = useViagemFechadaCancelar({
        onSuccess(data, variables, context) {
            refModal.current?.fechar();
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Viagem aberta com sucesso."
            });

            onSuccess?.(data, variables, context);
        },
    });

    return <TelaCarregamento ativo={isLoadingFechamentoRelatorio || isPendingFechamentoRelatorio}>
        <ComponentePermissao permissoes={isAlteracao ? ["ViagemReabrirViagem"] : ["ViagemEncerrarViagem"]}>
            <ModalBase
                title={title ?? (isAlteracao ? "Reabrir Viagem" : "Fechar Viagem")}
                width={width ?? "80vw"}
                ref={refModal}
                onOk={(e) => {
                    refForm.current?.submit();
                    onOk?.(e);
                }}
                onCancel={(e) => {
                    refForm.current?.resetFields();
                    refModal.current?.fechar();
                    onCancel?.(e);
                }}
                textButtonOpen={isAlteracao ? "Reabrir Viagem" : "Fechar Viagem"}
                propsButtonOpen={{
                    ...propsButtonOpen,
                    danger : isAlteracao
                }}
                confirmLoading={isPending || isPendingCancelar || isLoadingFechamentoRelatorio || isPendingFechamentoRelatorio}
                {...rest}
            >
                <ViagemFechadaFormBasic 
                    ref={refForm} 
                    initialValues={initialValues}
                    onFinish={isAlteracao ? cancelar : mutate}
                />
            </ModalBase>
        </ComponentePermissao>
    </TelaCarregamento>;
}